// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3AuIG","box":"WorkspacesBox_box__1tK88","node":"WorkspacesBox_node__3AU_O"};